module.exports = __webpack_public_path__ + "400815a5f1ce1d2155b27a4a9e2318cc.png";